const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "STATIONS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "STATIONS_RESET_FILTERS":
      return {
        ...state,
        filters: {
          open: true,
          query: {},
        },
      };
    case "STATIONS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "STATIONS_LOADING":
      return {
        ...state,
        status: "loading",
      };

    case "STATIONS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "STATIONS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "STATIONS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
